import { t } from '@lingui/core/macro';
import { NoddiButton, NoddiCard } from 'noddi-ui-web';

type Props = {
  supportEmail: string;
  supportPhone: string;
};

/** Customer service of the booking's own department, one tap from a call or an email. */
export const BSlugSupportCard = ({ supportEmail, supportPhone }: Props) => (
  <NoddiCard size='small'>
    <div className='flex flex-wrap items-center justify-between gap-3'>
      <div className='flex min-w-0 flex-col'>
        <p className='text-sm font-semibold'>{t`Questions about your booking?`}</p>
        <p className='text-sm text-muted-foreground'>{t`Contact our customer service.`}</p>
      </div>
      {/* On the service day a call answers faster than an email; the department may have no phone. */}
      <div className='flex shrink-0 gap-2'>
        {supportPhone && (
          <NoddiButton asChild variant='outline' size='small' startIcon='Phone'>
            <a href={`tel:${supportPhone}`}>{t`Call`}</a>
          </NoddiButton>
        )}
        <NoddiButton asChild variant='outline' size='small' startIcon='Mail'>
          <a href={`mailto:${supportEmail}`}>{t`Email`}</a>
        </NoddiButton>
      </div>
    </div>
  </NoddiCard>
);
